
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
components: {
Cell,
XHeader,
Group,
XButton
},
created: function () {
document.title = '加入代理'
this.$vux.loading.show('数据加载中')
this.$http.get(this.tianYiWebUrl + '/wechat/area/ajaxGetProvenceList').then(r => {

this.provence = r.data.data.p
this.clickProvence(this.provence[0])
this.$vux.loading.hide()
})
},

data() {
return {

showIndex: 0,

provence: [],

currentProvence: {
name: '',
join_fee: ''
},

city: [],
}
},
methods: {
clickProvence(i) {
this.currentProvence = i
this.$vux.loading.show('数据加载中')
this.$http.get(this.tianYiWebUrl + '/wechat/area/ajaxGetCityAndRegion', {params: {provenceId: i.id}}).then(r => {
if (r.data.code === 200) {
this.city = r.data.data
this.$vux.loading.hide()
}
})
},
clickCity(c) {
this.showIndex = this.showIndex === c.id ? 0 : c.id
}
}
}



// WEBPACK FOOTER //
// ./src/components/uc/Join.vue